var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PricingTopActionWrapper',{staticClass:"popup-wrapper"}),_c('PricingPageAlert'),_c('PricingSheet')],1)}
var staticRenderFns = []

export { render, staticRenderFns }